import { parseFountainToElements } from '@/features/studio/script/fountain-parse'
import type { ScriptConvention } from '@/features/studio/script/useScriptFormatPrefs'

export type DerivedScene = {
  scene_no: number
  heading: string
  body: string
}

export function deriveScenesFromBody(body: string, convention: ScriptConvention): DerivedScene[] {
  const elements = parseFountainToElements(body, convention)
  const scenes: DerivedScene[] = []
  for (const el of elements) {
    if (el.type !== 'scene_heading' || !el.sceneNo) continue
    const heading = el.content.split('\n')[0]?.trim() ?? ''
    scenes.push({
      scene_no: el.sceneNo,
      heading,
      body: el.content,
    })
  }
  return scenes
}
